import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        conferencename: "Øredev 2025",
        count: 0,
        sessions: [],
        speakers: [],
        scheduleGrid: [],
        all: [],
    },
    getters,
    mutations,
    actions
});


// WEBPACK FOOTER //
// ./src/store/index.js